<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">广播详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="设备名称" prop="equipmentName">
                <el-input
                  v-model="data.equipmentName"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设备编号" prop="equipmentNo">
                <el-input
                  v-model="data.equipmentNo"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- <el-col :span="12">
              <el-form-item label="设备简称" prop="ShortName">
                <el-input
                  v-model="data.ShortName"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="IP地址" prop="equipmentIp">
                <el-input
                  v-model="data.equipmentIp"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="12">
              <el-form-item label="保修期" prop="WarrantyPeriod">
                <el-input
                  v-model="data.WarrantyPeriod"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="经度" prop="longitude">
                <el-input
                  v-model="data.longitude"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="纬度" prop="latitude">
                <el-input
                  v-model="data.latitude"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <ZjLngLatSelect
              class="newtaskposition"
              :point_lat="data.Latitude"
              :point_lng="data.Longitude"
              @onGotLngLat="onGotLngLat"
            ></ZjLngLatSelect>
            <!-- <el-button @click="getCurrentPostion()" style="margin-left:1.5rem;">定位</el-button> -->
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="位置" prop="equipmentLocation">
                <el-input
                  v-model="data.equipmentLocation"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="区域" prop="areaCode">
                <treeselect
                  v-model="data.areaCode"
                  :options="EqRegionArr"
                  :disabled="!IsEdit"
                  noResultsText="暂无选择项"
                  placeholder="请选择区域"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="描述" prop="equipmentDesc">
                <el-input
                  v-model="data.equipmentDesc"
                  :disabled="!IsEdit"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
// import MyApis from "../../../apis";
// import ZJApp from "../../../../../app";
import { addEquipment, getEquipmentById, updateEquipment } from "@/api/src/equipment";
export default {
  name: "DeviceManagerInfo",
  controller: "UI",
  action: "DeviceManagerInfo",
  components: {
    Treeselect
  },
  data() {
    return {
      data: {
        categoryCode:"broadcast",
        equipmentName:"",
        equipmentNo:"",
        equipmentIp:"",
        areaCode:"",
        equipmentDesc: "",
        latitude: "",
        longitude: "",
        equipmentLocation:""
      },
      EqRegionArr: [],
      IsEdit: false,
      rules: {
        equipmentName: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
        ],
      },
    };
  },
  created: function() {
    if(this.$route.query.areaTree){
      this.EqRegionArr = this.$route.query.areaTree
    }
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  watch: {
    $route: function() {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },
  methods: {
    onGotLngLat(obj) {
      this.data.latitude = obj.lat || 0;
      this.data.longitude = obj.lng || 0;
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        getEquipmentById(InfoId).then(res=>{
          if(res.code==200){
            this.data = res.data;
          }
        })
        // new MyApis.TranResourcesApi()
        //   .GetEquipmentById({ deviceId: InfoId })
        //   .then((r) => {
        //     r = r.data.Data;
        //     console.log(r);
        //     this.data = r;
        //     this.data.JsonExtend = JSON.parse(this.data.JsonExtend);
        //   })
        //   .catch((e) => {
        //     console.log(e);
        //     this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        //   });
      }
    },
    //返回按钮
    onBack() {
      // this.$router.go(-1); //返回上一层
      this.$router.push({
        path: "/plugin/broadcast/UI/DeviceManagerView",
        // query: {
        //   areaTree: this.regionDataTree,
        //   type: "add",
        // },
      });
    },
    //保存
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      if (this.$route.query.type == "edit") {
        //编辑
        updateEquipment(this.data).then(res=>{
          if(res.code==200){
            this.$message({
              type: "success",
              message: "保存成功！"
            });
            this.$router.go(-1); //返回上一层
          }else{
            this.errmsg("保存失败！");
          }
        })
      
      } else {
        // 增加
 
        addEquipment(this.data).then(res=>{
          if(res.code==200){
            this.$message({
              type: "success",
              message: "保存成功！"
            });
            this.$router.go(-1); //返回上一层
          }else{
            this.errmsg("保存失败！");
          }
        })
      }
    },
  },
};
</script>

<style scoped>
::v-deep .vue-treeselect__control{
  height: 4rem;
}
::v-deep .vue-treeselect__placeholder, 
::v-deep .vue-treeselect__single-value{
  line-height: unset;
}
::v-deep .vue-treeselect__control,
::v-deep .vue-treeselect--open-below,
::v-deep .vue-treeselect__menu{
  border-radius: 0;
}
</style>